<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.Reference"
                        label="Reference (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.Reference || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.Manufacturer"
                        label="Manufacturer (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.Manufacturer || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.Manufacturer_ID"
                        label="Manufacturer_ID"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.ModuleId"
                        label="ModuleId"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.Name"
                        label="Module Name (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.Name || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.PModMPP"
                        label="PModMPP (Wp) (*)"
                        :rules="[() => $store.state.modulesEditedItem.PModMPP > 0 || 'La puissance crête doit être renseignée !']"
                        :error-messages="$store.state.errorMessages"
                        type="number"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.CellType"
                        label="CellType (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.CellType || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="4"
                    sm="4"
                    md="4"
                >
                    <v-checkbox
                        v-model="$store.state.modulesEditedItem.FullBlack"
                        label="FullBlack"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="4"
                    sm="4"
                    md="4"
                >
                    <v-checkbox
                        v-model="$store.state.modulesEditedItem.Bisun"
                        label="Bisun"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="4"
                    sm="4"
                    md="4"
                >
                    <v-checkbox
                        v-model="$store.state.modulesEditedItem.optimizer"
                        label="optimizer"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.MaleConnector"
                        label="MaleConnector (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.MaleConnector || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.FemaleConnector"
                        label="FemaleConnector (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.FemaleConnector || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.YmaleConnector"
                        label="YmaleConnector (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.YmaleConnector || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.YfemaleConnector"
                        label="YfemaleConnector (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.YfemaleConnector || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.mc4FuseType"
                        label="mc4FuseType (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.mc4FuseType || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                <v-text-field
                        v-model="$store.state.modulesEditedItem.ModuleAlias1"
                        label="ModuleAlias1 (*)"
                        :rules="[() => !!$store.state.modulesEditedItem.ModuleAlias1 || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.ModuleAlias2"
                        label="ModuleAlias2"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.ModuleAlias3"
                        label="ModuleAlias3"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.ModuleAlias4"
                        label="ModuleAlias4"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                    <v-text-field
                        v-model="$store.state.modulesEditedItem.ModuleAlias5"
                        label="ModuleAlias5"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
        </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireModules",
		data: function () {
			return {
            }
        }
    }
</script>
